<template>
<div class="chapter">
<div class="inner_page">
<h2 class="ch-titlej"><a id="page4">Acknowledgements</a></h2><a id="page4">
<p class="noindent1">A book of this nature would not have been possible without the help of many people and organisations too numerous to individually mention. I am indebted to many people and organisations for providing photographs for this story, but in some cases it has not been possible to identify the original photographer and so credits are given in the appropriate places to the immediate supplier. If any of the pictures have not been correctly credited, please accept my apologies.</p>
<p class="noindent1">I would however, like to offer my special thanks the Fellows, Members and Associates of the Worldwide Society of Civil Aviation Enthusiasts (WSCAE) - many of whom work in the global aviation industry as flight or ground crew or indeed ‘on the spanners’ - for letting me have free access to their collections, including Dee Diddley, Ameen Yasheed, Wan Hunglo, John Hamlin, Bob Lehat, Kirk Smeeton, Ian Frimston, Carrie Åberg, Simon Peters, Robin Banks, Rick O’Shea, Hugh Jampton, Peter Clegg, Hank Warton, Matt Black, David Lee, Bill Armstrong, Emma Dayle, Dr Harry Friedman, Jack Malloch, and Trymore Simango.</p>
<p class="noindent1">Thanks also go to the executors of the estate of the late Klaas Jurjen Prins, Brian Cocks, Martin Mace, Laura Hirst, Charles Hewitt, Matthew Potts, Harriet Fielding, Amy Jordan, Lori Jones and all at Pen &amp; Sword.</p>
<p class="noindent1">Finally, and by no means least, my special heartfelt thanks to my wife Anne.</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Acknowledgement.vue?11370692